import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import Raven from 'raven-js';

class ErrorBoundaryPage extends React.Component {
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  state = { error: null }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    Raven.captureException(error, { extra: info });
  }

  render() {
    if (this.state.error !== null) {
      // You can render any custom fallback UI
      return (
        <div style={{ margin: 'auto', textAlign: 'center' }}>
          <Helmet>
            <title>Ошибка на странице</title>
          </Helmet>

          <h1>С текущей страницей что-то не так :(</h1>
          <p>{String(this.state.error)}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

ErrorBoundaryPage.propTypes = {
  children: PropTypes.node,
};

ErrorBoundaryPage.defaultProps = {
  children: null,
};

export default ErrorBoundaryPage;
